import { render, staticRenderFns } from "./entidad.vue?vue&type=template&id=896c805a"
import script from "./entidad.vue?vue&type=script&lang=js"
export * from "./entidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports